import { lazy } from 'react';
import { paths } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import { type TypedRouteObject } from '../types';

// 동적 임포트
const Dashboard = lazy(() => import('@/pages/dashboard/Dashboard'));

/**
 * 대시보드 라우트
 */
export const dashboardRoutes: TypedRouteObject = {
	children: [
		{
			path: paths.home,
			element: withSuspense(Dashboard)
		},
		{
			path: paths.dashboard,
			element: withSuspense(Dashboard)
		}
	]
};
